export const EDIT_DAILY_DEPOSIT_LOADING = 'EDIT_DAILY_DEPOSIT_LOADING';
export const EDIT_DAILY_DEPOSIT_FETCHING = 'EDIT_DAILY_DEPOSIT_FETCHING';
export const EDIT_DAILY_DEPOSIT_FETCH_ERROR = 'EDIT_DAILY_DEPOSIT_FETCH_ERROR';
export const EDIT_DAILY_DEPOSIT_GET_DATA = 'EDIT_DAILY_DEPOSIT_GET_DATA';
export const EDIT_DAILY_DEPOSIT_CLEAR_STATE = 'EDIT_DAILY_DEPOSIT_CLEAR_STATE';
export const EDIT_DAILY_DEPOSIT_GET_SITES = 'EDIT_DAILY_DEPOSIT_GET_SITES';
export const EDIT_DAILY_DEPOSIT_NEW_ID = 'EDIT_DAILY_DEPOSIT_NEW_ID';



// WEBPACK FOOTER //
// ./src/pages/modifydailydeposits/state/editdailydeposit/types.js